<div class="card p-4 p-lg-4 rounded-4 border-0 marketing-actions-card">
    <div class="px-2">
        <!-- Header Section -->
        <div class="d-flex col-12 justify-content-between align-items-start flex-wrap gap-3 mb-2">
            <div class="col-md-5">
                <h2 class="syne-text fw-bold fs-32 text-dark mb-1">
                    {{ 'mkt_title' | translate }}
                </h2>
                <div class="fw-semibold syne-text fs-18 text-dark mb-3">
                    {{ 'mkt_subtitle' | translate }}
                </div>
                <p class="fs-16 mb-0">
                    {{ 'mkt_description' | translate }}
                </p>
            </div>
            <div class="col-md-5 fw-semibold fs-16 text-end ms-auto mt-1">
                {{ 'mkt_vat_excluded' | translate }}
            </div>
        </div>

        <!-- Info Alert Banner -->
        <div class="info-alert-pill d-flex align-items-center py-2 px-3 my-4">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#244F98" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" class="me-2 flex-shrink-0">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span class="fs-16 text-dark">
                {{ 'mkt_alert_info' | translate }}
            </span>
        </div>

        <!-- CARD 01: DEM (Direct Email Marketing) -->
        <div class="marketing-card bdr-black p-4 p-lg-6 mb-4 mt-3">
            <div class="row align-items-start g-4">
                <!-- Left Column: 01 Badge + Title + Description -->
                <div class="col-12 col-lg-5 col-xl-6">
                    <div class="d-flex mb-1">
                        <span class="badge-number fs-17 d-inline-flex align-items-center justify-content-center
                         rounded-circle text-white flex-shrink-0 shadow-none">01</span>
                    </div>
                    <h3 class="syne-text fw-semibold fs-25 text-dark mb-3 mt-2">{{ 'mkt_dem_title' | translate }}</h3>
                    <p class="fs-16 lh-base pe-4 mb-0">
                        {{ 'mkt_dem_desc' | translate }}
                    </p>
                </div>

                <!-- Right Column: Packages + Audience stats (with prominent gap from left) -->
                <div class="col-12 col-lg-6 col-xl-6 ms-lg-auto ps-5">
                    <div class="syne-text fs-20 mb-3 mt-1">{{ 'mkt_packages_label' | translate }}</div>
                    <div class="row g-4 mb-4">
                        <div class="col-6">
                            <div class="package-box p-3 text-center h-100"
                                [class.selected]="selectedDemPackage === 'mkt_dem_pkg_national'"
                                [class.blink-alert]="blinkSection['dem'] && !selectedDemPackage"
                                (click)="selectDem('mkt_dem_pkg_national')">
                                <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_dem_pkg_national' | translate }}
                                </div>
                                <div class="fs-16 text-secondary mb-2">{{ 'mkt_dem_pkg_national_sub' | translate }}
                                </div>
                                <div class="fs-16 text-dark">{{ 'mkt_dem_pkg_national_price' | translate }}</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="package-box p-3 text-center h-100"
                                [class.selected]="selectedDemPackage === 'mkt_dem_pkg_global'"
                                [class.blink-alert]="blinkSection['dem'] && !selectedDemPackage"
                                (click)="selectDem('mkt_dem_pkg_global')">
                                <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_dem_pkg_global' | translate }}
                                </div>
                                <div class="fs-16 text-secondary mb-2">{{ 'mkt_dem_pkg_global_sub' | translate }}</div>
                                <div class="fs-16 text-dark">{{ 'mkt_dem_pkg_global_price' | translate }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="fs-16 text-secondary mb-0">
                        <div class="mb-1">{{ 'mkt_dem_note_national' | translate }}</div>
                        <div>{{ 'mkt_dem_note_global' | translate }}</div>
                    </div>
                </div>
            </div>

            <!-- Contact Button in Middle of Whole Card -->
            <div class="text-center mt-4 pt-2">
                <button class="btn btn-contact fs-16 fw-medium border-0"
                    (click)="onContact('mkt_dem_title', selectedDemPackage, true, 'dem')">
                    {{ 'contact_us_plan' | translate }}
                </button>
                <div *ngIf="validationErrors['dem']" class="text-danger fs-14 mt-2">
                    {{ 'mkt_select_package_alert' | translate }}
                </div>
            </div>
        </div>

        <!-- CARD 02: Campagne di visibilità -->
        <div class="marketing-card bdr-black p-4 p-lg-6 mb-4 mt-3">
            <div class="row align-items-start g-4">
                <!-- Left Column: 02 Badge + Title + Description -->
                <div class="col-12 col-lg-4 col-xl-4">
                    <div class="d-flex mb-1">
                        <span class="badge-number fs-17 d-inline-flex align-items-center justify-content-center rounded-circle 
                         text-white flex-shrink-0 shadow-none">02</span>
                    </div>
                    <h3 class="syne-text fw-semibold fs-25 text-dark mb-3 mt-2">{{ 'mkt_campaigns_title' | translate }}
                    </h3>
                    <p class="fs-16 lh-base pe-lg-3 mb-0">
                        {{ 'mkt_campaigns_desc' | translate }}
                    </p>
                </div>

                <!-- Right Column: Packages with generous gap between cards and flex alignment for tick & text -->
                <div class="col-12 col-lg-8 col-xl-8 ms-lg-auto ps-lg-4">
                    <div class="syne-text fs-20 mb-3 mt-1">{{ 'mkt_packages_label' | translate }}</div>
                    <div class="row g-3 g-xl-4 mb-0">
                        <!-- Bronze -->
                        <div class="col-12 col-md-4">
                            <div class="package-box p-3 p-xl-3 h-100 d-flex flex-column text-start"
                                [class.selected]="selectedCampagnePackage === 'mkt_pkg_bronze'"
                                [class.blink-alert]="blinkSection['campagne'] && !selectedCampagnePackage"
                                (click)="selectCampagne('mkt_pkg_bronze')">
                                <div class="fw-bold fs-16 text-center text-dark mb-3">{{ 'mkt_pkg_bronze' | translate }}
                                </div>

                                <!-- Feature 1: Banner + Durata -->
                                <div class="d-flex align-items-start mb-3">
                                    <svg width="15" height="15" viewBox="0 0 16 16" fill="none"
                                        class="me-2 flex-shrink-0 mt-1" aria-hidden="true">
                                        <path d="M2.5 8.5L6 12L13.5 3.5" stroke="#E54424" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div class="fs-16 text-dark lh-sm">
                                        <div>{{ 'mkt_pkg_bronze_f1' | translate }}</div>
                                        <div class="mt-1" [innerHTML]="'mkt_duration_10' | translate"></div>
                                    </div>
                                </div>

                                <!-- Feature 2: DEM -->
                                <div class="d-flex align-items-start mb-3">
                                    <svg width="15" height="15" viewBox="0 0 16 16" fill="none"
                                        class="me-2 flex-shrink-0 mt-1" aria-hidden="true">
                                        <path d="M2.5 8.5L6 12L13.5 3.5" stroke="#E54424" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div class="fs-16 text-dark lh-sm" [innerHTML]="'mkt_pkg_bronze_f2' | translate">
                                    </div>
                                </div>

                                <div class="fs-16 text-center text-dark mt-auto pt-3">{{ 'mkt_pkg_bronze_price' |
                                    translate }}</div>
                            </div>
                        </div>

                        <!-- Silver -->
                        <div class="col-12 col-md-4">
                            <div class="package-box p-3 p-xl-3 h-100 d-flex flex-column text-start"
                                [class.selected]="selectedCampagnePackage === 'mkt_pkg_silver'"
                                [class.blink-alert]="blinkSection['campagne'] && !selectedCampagnePackage"
                                (click)="selectCampagne('mkt_pkg_silver')">
                                <div class="fw-bold fs-16 text-center text-dark mb-3">{{ 'mkt_pkg_silver' | translate }}
                                </div>

                                <!-- Feature 1: Banner + Durata -->
                                <div class="d-flex align-items-start mb-3">
                                    <svg width="15" height="15" viewBox="0 0 16 16" fill="none"
                                        class="me-2 flex-shrink-0 mt-1" aria-hidden="true">
                                        <path d="M2.5 8.5L6 12L13.5 3.5" stroke="#E54424" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div class="fs-16 text-dark lh-sm">
                                        <div>{{ 'mkt_pkg_silver_f1' | translate }}</div>
                                        <div class="mt-1" [innerHTML]="'mkt_duration_20' | translate"></div>
                                    </div>
                                </div>

                                <!-- Feature 2: DEM -->
                                <div class="d-flex align-items-start mb-3">
                                    <svg width="15" height="15" viewBox="0 0 16 16" fill="none"
                                        class="me-2 flex-shrink-0 mt-1" aria-hidden="true">
                                        <path d="M2.5 8.5L6 12L13.5 3.5" stroke="#E54424" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div class="fs-16 text-dark lh-sm" [innerHTML]="'mkt_pkg_silver_f2' | translate">
                                    </div>
                                </div>

                                <div class="fs-16 text-center text-dark mt-auto pt-3">{{ 'mkt_pkg_silver_price' |
                                    translate }}</div>
                            </div>
                        </div>

                        <!-- Gold -->
                        <div class="col-12 col-md-4">
                            <div class="package-box p-3 p-xl-3 h-100 d-flex flex-column text-start"
                                [class.selected]="selectedCampagnePackage === 'mkt_pkg_gold'"
                                [class.blink-alert]="blinkSection['campagne'] && !selectedCampagnePackage"
                                (click)="selectCampagne('mkt_pkg_gold')">
                                <div class="fw-bold fs-16 text-center text-dark mb-3">{{ 'mkt_pkg_gold' | translate }}
                                </div>

                                <!-- Feature 1: Banner + Durata -->
                                <div class="d-flex align-items-start mb-3">
                                    <svg width="15" height="15" viewBox="0 0 16 16" fill="none"
                                        class="me-2 flex-shrink-0 mt-1" aria-hidden="true">
                                        <path d="M2.5 8.5L6 12L13.5 3.5" stroke="#E54424" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div class="fs-16 text-dark lh-sm">
                                        <div>{{ 'mkt_pkg_gold_f1' | translate }}</div>
                                        <div class="mt-1" [innerHTML]="'mkt_duration_30' | translate"></div>
                                    </div>
                                </div>

                                <!-- Feature 2: DEM -->
                                <div class="d-flex align-items-start mb-3">
                                    <svg width="15" height="15" viewBox="0 0 16 16" fill="none"
                                        class="me-2 flex-shrink-0 mt-1" aria-hidden="true">
                                        <path d="M2.5 8.5L6 12L13.5 3.5" stroke="#E54424" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div class="fs-16 text-dark lh-sm" [innerHTML]="'mkt_pkg_gold_f2' | translate">
                                    </div>
                                </div>

                                <div class="fs-16 text-center text-dark mt-auto pt-3">{{ 'mkt_pkg_gold_price' |
                                    translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Contact Button in Middle of Whole Card -->
            <div class="text-center mt-4 pt-3">
                <button class="btn btn-contact fs-16 fw-medium border-0"
                    (click)="onContact('mkt_campaigns_title', selectedCampagnePackage, true, 'campagne')">
                    {{ 'contact_us_plan' | translate }}
                </button>
                <div *ngIf="validationErrors['campagne']" class="text-danger fs-14 mt-2">
                    {{ 'mkt_select_package_alert' | translate }}
                </div>
            </div>
        </div>

        <!-- CARD 03: Visibilità onsite -->
        <div class="marketing-card bdr-black p-4 p-lg-6 mb-4 mt-3">
            <div class="row align-items-start g-4">
                <!-- Left Column: 03 Badge + Title + Description -->
                <div class="col-12 col-lg-4 col-xl-3">
                    <div class="d-flex mb-1">
                        <span class="badge-number fs-17 d-inline-flex align-items-center justify-content-center rounded-circle 
                         text-white flex-shrink-0 shadow-none">03</span>
                    </div>
                    <h3 class="syne-text fw-semibold fs-25 text-dark mb-3 mt-2">{{ 'mkt_onsite_title' | translate }}
                    </h3>
                    <p class="fs-16 lh-base pe-lg-2 mb-0">
                        {{ 'mkt_onsite_desc' | translate }}
                    </p>
                </div>

                <!-- Right Column: Header & Stacked Sub-boxes -->
                <div class="col-12 col-lg-8 col-xl-9 ms-lg-auto ps-lg-5">
                    <!-- Right Column Intro Header -->
                    <div class="mb-4 ps-3">
                        <div class="fs-20 text-dark mb-2">
                            {{ 'mkt_onsite_box_header' | translate }}
                        </div>
                        <p class="fs-16 lh-base text-dark mb-0">
                            {{ 'mkt_onsite_box_desc' | translate }}
                        </p>
                    </div>

                    <!-- Sub-box 3.1: Banner a rotazione nel feed -->
                    <div class="sub-box bdr-black p-4 mb-4">
                        <h4 class="fw-medium fs-20 text-dark mb-2">
                            {{ 'mkt_feed_banner_title' | translate }}
                        </h4>
                        <p class="fs-16 text-dark mb-4">
                            {{ 'mkt_feed_banner_desc' | translate }}
                        </p>
                        <div class="row g-3 g-xl-4 mb-4">
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedFeedPackage === 'mkt_pkg_sprint'"
                                    [class.blink-alert]="blinkSection['feed'] && !selectedFeedPackage"
                                    (click)="selectFeed('mkt_pkg_sprint')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_sprint' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_sprint_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_500_10' | translate }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedFeedPackage === 'mkt_pkg_momentum'"
                                    [class.blink-alert]="blinkSection['feed'] && !selectedFeedPackage"
                                    (click)="selectFeed('mkt_pkg_momentum')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_momentum' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_momentum_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_1000_20' | translate }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedFeedPackage === 'mkt_pkg_domino'"
                                    [class.blink-alert]="blinkSection['feed'] && !selectedFeedPackage"
                                    (click)="selectFeed('mkt_pkg_domino')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_domino' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_domino_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_1500_30' | translate }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-3 pt-1">
                            <button class="btn btn-contact fs-16 fw-medium border-0"
                                (click)="onContact('mkt_feed_banner_title', selectedFeedPackage, true, 'feed')">
                                {{ 'contact_us_plan' | translate }}
                            </button>
                            <div *ngIf="validationErrors['feed']" class="text-danger fs-14 mt-2">
                                {{ 'mkt_select_package_alert' | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Sub-box 3.2: Banner fisso nella sidebar -->
                    <div class="sub-box bdr-black p-4 mb-4">
                        <h4 class="syne-text fw-semibold fs-20 text-dark mb-2">
                            {{ 'mkt_sidebar_banner_title' | translate }}
                        </h4>
                        <p class="fs-16 text-dark mb-4">
                            {{ 'mkt_sidebar_banner_desc' | translate }}
                        </p>
                        <div class="row g-3 g-xl-4 mb-4">
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedSidebarPackage === 'mkt_pkg_sprint'"
                                    [class.blink-alert]="blinkSection['sidebar'] && !selectedSidebarPackage"
                                    (click)="selectSidebar('mkt_pkg_sprint')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_sprint' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_sprint_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_1000_10' | translate }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedSidebarPackage === 'mkt_pkg_momentum'"
                                    [class.blink-alert]="blinkSection['sidebar'] && !selectedSidebarPackage"
                                    (click)="selectSidebar('mkt_pkg_momentum')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_momentum' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_momentum_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_1500_20' | translate }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedSidebarPackage === 'mkt_pkg_domino'"
                                    [class.blink-alert]="blinkSection['sidebar'] && !selectedSidebarPackage"
                                    (click)="selectSidebar('mkt_pkg_domino')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_domino' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_domino_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_2000_30' | translate }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-3 pt-1">
                            <button class="btn btn-contact fs-16 fw-medium border-0"
                                (click)="onContact('mkt_sidebar_banner_title', selectedSidebarPackage, true, 'sidebar')">
                                {{ 'contact_us_plan' | translate }}
                            </button>
                            <div *ngIf="validationErrors['sidebar']" class="text-danger fs-14 mt-2">
                                {{ 'mkt_select_package_alert' | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Sub-box 3.3: Logo fisso nella sidebar -->
                    <div class="sub-box bdr-black p-4 mb-0">
                        <h4 class="syne-text fw-semibold fs-20 text-dark mb-2">
                            {{ 'mkt_sidebar_logo_title' | translate }}
                        </h4>
                        <p class="fs-16 text-dark mb-4">
                            {{ 'mkt_sidebar_logo_desc' | translate }}
                        </p>
                        <div class="row g-3 g-xl-4 mb-4">
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedLogoPackage === 'mkt_pkg_sprint'"
                                    [class.blink-alert]="blinkSection['logo'] && !selectedLogoPackage"
                                    (click)="selectLogo('mkt_pkg_sprint')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_sprint' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_sprint_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_200_10' | translate }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedLogoPackage === 'mkt_pkg_momentum'"
                                    [class.blink-alert]="blinkSection['logo'] && !selectedLogoPackage"
                                    (click)="selectLogo('mkt_pkg_momentum')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_momentum' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_momentum_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_400_20' | translate }}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="package-box p-3 text-center h-100"
                                    [class.selected]="selectedLogoPackage === 'mkt_pkg_domino'"
                                    [class.blink-alert]="blinkSection['logo'] && !selectedLogoPackage"
                                    (click)="selectLogo('mkt_pkg_domino')">
                                    <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_pkg_domino' | translate }}</div>
                                    <div class="fs-16 text-dark mb-2">{{ 'mkt_pkg_domino_sub' | translate }}</div>
                                    <div class="fs-16 text-dark">{{ 'mkt_price_600_30' | translate }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-3 pt-1">
                            <button class="btn btn-contact fs-16 fw-medium border-0"
                                (click)="onContact('mkt_sidebar_logo_title', selectedLogoPackage, true, 'logo')">
                                {{ 'contact_us_plan' | translate }}
                            </button>
                            <div *ngIf="validationErrors['logo']" class="text-danger fs-14 mt-2">
                                {{ 'mkt_select_package_alert' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD 04: iFrame -->
        <div class="marketing-card bdr-black p-4 p-lg-6 mb-4 mt-3">
            <div class="row align-items-center g-4">
                <div class="col-12 col-lg-5 col-xl-7">
                    <div class="d-flex mb-1">
                        <span class="badge-number fs-17 d-inline-flex align-items-center justify-content-center rounded-circle 
                         text-white flex-shrink-0 shadow-none">04</span>
                    </div>
                    <h3 class="syne-text fw-semibold fs-25 text-dark mb-3 mt-2">{{ 'mkt_iframe_title' | translate }}
                    </h3>
                    <p class="fs-16 lh-base pe-4 mb-0">
                        {{ 'mkt_iframe_desc' | translate }}
                    </p>
                </div>

                <div class="col-12 col-lg-6 col-xl-5 ms-lg-auto ps-5">
                    <div class="d-flex align-items-center justify-content-lg-end flex-wrap gap-4">
                        <div>
                            <div class="syne-text fs-20 mb-3 mt-1">{{ 'mkt_package_single_label' | translate }}</div>
                            <div class="package-box p-3 px-5 text-center cursor-pointer"
                                [class.selected]="selectedIframe"
                                [class.blink-alert]="blinkSection['iframe'] && !selectedIframe"
                                (click)="toggleIframe()">
                                <div class="fw-bold fs-16 text-dark mb-1">{{ 'mkt_iframe_pkg_name' | translate }}
                                </div>
                                <div class="fs-16 text-dark">{{ 'mkt_iframe_price' | translate }}</div>
                            </div>
                        </div>
                        <div class="pt-lg-4">
                            <button class="btn btn-contact fs-16 fw-medium border-0"
                                (click)="onContact('mkt_iframe_title', selectedIframe ? 'mkt_iframe_pkg_name' : '', true, 'iframe')">
                                {{ 'contact_us_plan' | translate }}
                            </button>
                            <div *ngIf="validationErrors['iframe']" class="text-danger fs-14 mt-2">
                                {{ 'mkt_select_package_alert' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- CARD 05: Content & supporto editoriale -->
        <div class="marketing-card bdr-black p-4 p-lg-6 mb-4 mt-3">
            <div class="row align-items-center g-4">
                <div class="col-12 col-lg-5 col-xl-6">
                    <div class="d-flex mb-1">
                        <span class="badge-number fs-17 d-inline-flex align-items-center justify-content-center rounded-circle 
                         text-white flex-shrink-0 shadow-none">05</span>
                    </div>
                    <h3 class="syne-text fw-semibold fs-25 text-dark mb-3 mt-2">{{ 'mkt_content_title' | translate }}
                    </h3>
                    <p class="fs-16 lh-base pe-4 mb-0">
                        {{ 'mkt_content_desc' | translate }}
                    </p>
                </div>

                <div class="col-12 col-lg-6 col-xl-6 ms-lg-auto ps-5">
                    <div class="d-flex align-items-center justify-content-lg-between flex-wrap px-4 gap-4">
                        <div class="fs-20">
                            {{ 'mkt_service_on_request' | translate }}
                        </div>
                        <div>
                            <button class="btn btn-contact fs-16 fw-medium border-0"
                                (click)="onContact('mkt_content_title', 'mkt_service_on_request', false)">
                                {{ 'contact_us_plan' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Contact Confirmation Modal -->
<div class="modal fade" id="marketingContactModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg rounded-4 p-4 px-5 position-relative text-center">
            <button type="button" class="btn-close position-absolute end-0 top-0 m-3" data-bs-dismiss="modal"
                (click)="closeModal()" aria-label="Close">
            </button>
            <div class="my-3">
                <i class="skf-yes fs-40 d-inline-block" style="width: 48px; height: 48px;"></i>
            </div>
            <h3 class="fs-25 syne-text mb-3 fw-bold text-dark">
                {{ 'thanks_for_contact' | translate }}
            </h3>
            <p class="text-secondary fs-16 mb-2">
                {{ 'mkt_modal_requested_for' | translate }}
            </p>
            <div class="p-3 bg-light rounded-3 mb-3">
                <div class="fw-bold syne-text fs-16 text-dark" *ngIf="requestedServiceKey">
                    {{ requestedServiceKey | translate }}
                </div>
                <div class="text-muted fs-14" *ngIf="requestedPackageKey">
                    {{ requestedPackageKey | translate }}
                </div>
            </div>
            <p class="text-secondary fs-14 mb-4">
                {{ 'plan_contact_text' | translate }}
            </p>
            <div class="d-flex justify-content-center">
                <button class="btn btn-primary rounded-pill px-5 py-2 fs-16" data-bs-dismiss="modal"
                    (click)="closeModal()">
                    {{ 'mkt_modal_close' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
